// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  FleetMapAreaDataTestIds,
  FleetMapAreaId,
  FleetMapAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  FleetMapAreaNavigation,
  FleetMapAreaNavigationIcon,
} from './FleetMapAreaNavigation'

const LazyFleetMapComponent = lazy(() => import('./FleetMapArea'))

const FleetMapComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetMapComponent />
  </SuspenseLoadingWrapper>
)

export const FleetMapArea = {
  id: FleetMapAreaId,
  dataTestIds: FleetMapAreaDataTestIds,
  requiredRight: BoumRight.AREA_FLEET_MAP,
  Icon: FleetMapAreaNavigationIcon,
  NavigationComponent: FleetMapAreaNavigation,
  route: {
    path: FleetMapAreaRoutes.route,
    component: FleetMapComponent,
  },
}
